var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "46.771px",
    viewBox: "0 0 48 46.771",
    enableBackground: "new 0 0 48 46.771",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#49021F",
    d: "M8.5,0h31C44.199,0,48,3.8,48,8.5v29.8c0,4.699-3.801,8.501-8.5,8.501h-31c-4.7,0-8.5-3.802-8.5-8.501V8.5 C0,3.8,3.8,0,8.5,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF3366",
    d: "M17.44,12.24v20.6c0,0.221-0.1,0.321-0.28,0.321h-3.92c-0.18,0-0.26-0.101-0.26-0.321v-20.6 c0-0.18,0.1-0.26,0.28-0.26h3.9c0.12-0.02,0.239,0.06,0.259,0.2C17.44,12.2,17.44,12.22,17.44,12.24L17.44,12.24z M29,33.4 c-1.48,0.021-2.961-0.28-4.3-0.899c-1.26-0.581-2.3-1.542-3.02-2.721c-0.74-1.221-1.099-2.741-1.099-4.561 c-0.02-1.48,0.359-2.94,1.099-4.22c0.76-1.3,1.861-2.38,3.181-3.1c1.399-0.78,3.079-1.16,5.06-1.16c0.1,0,0.24,0,0.42,0.02 c0.18,0.02,0.381,0.02,0.619,0.04v-6.32c0-0.14,0.063-0.22,0.201-0.22h4.061c0.1-0.02,0.18,0.061,0.199,0.14v19.079 c0,0.36,0.02,0.761,0.041,1.201c0.039,0.42,0.059,0.82,0.08,1.16c0,0.14-0.061,0.261-0.201,0.32 c-1.039,0.438-2.141,0.759-3.26,0.96C31.08,33.299,30.041,33.4,29,33.4L29,33.4z M30.959,29.399V20.6 c-0.18-0.04-0.359-0.081-0.539-0.1c-0.221-0.02-0.439-0.04-0.66-0.04c-0.779,0-1.561,0.16-2.26,0.52 c-0.68,0.34-1.26,0.84-1.699,1.479c-0.441,0.641-0.66,1.501-0.66,2.54c-0.02,0.701,0.1,1.401,0.34,2.061 c0.199,0.541,0.5,1.02,0.898,1.42c0.381,0.36,0.842,0.64,1.361,0.801c0.541,0.18,1.1,0.259,1.658,0.259 c0.301,0,0.582-0.019,0.842-0.04C30.5,29.521,30.74,29.479,30.959,29.399L30.959,29.399z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolid);
export default __webpack_public_path__ + "static/media/toolid.ad7e146c92d948f37b91e1f4a13493d3.svg";
export { ForwardRef as ReactComponent };